<template xmlns:v-slot="http://www.w3.org/1999/XSL/Transform">
  <v-container fluid grid-list-md>
    <v-layout row wrap>
      <v-flex xs12>
        <v-layout row>
          <v-flex xs12>
            <v-card>
              <card-toolbar title="Raporlar"> </card-toolbar>
              <v-card-text>
                <v-flex xs12>
                  <v-layout row v-if="$store.state.user.confirmation <= 3">
                    <v-flex xs12>
                      <dynamic-alert v-model="stationary">
                        <template v-slot:warning>
                          <v-form
                            action="http://www.oztekbayi.com/ara.php"
                            method="post"
                            target="_blank"
                          >
                            <div>
                              <b>
                                <input
                                  class="text-decorative"
                                  type="submit"
                                  :value="oztek.info"
                                />
                              </b>
                              <br />
                              <span
                                >SMS Raporları -> Raporlarda Arama -> Gönderim :
                                "Apiden" seçip arama yapınız.</span
                              >
                              <input
                                type="hidden"
                                name="ad"
                                :value="oztek.account.user_name"
                              />
                              <input
                                type="hidden"
                                name="sifre"
                                :value="oztek.account.password"
                              />
                              <input type="hidden" name="sif" value="wer" />
                            </div>
                          </v-form>
                        </template>
                      </dynamic-alert>
                    </v-flex>
                  </v-layout>
                  <!-- RAPORLAR -->
                  <v-layout
                    :row="$vuetify.breakpoint.smAndDown"
                    :wrap="!$vuetify.breakpoint.xl"
                  >
                    <!-- FİLTRE -->
                    <v-flex md12 xs12 xl3>
                      <v-form
                        ref="form"
                        v-model="isFormValid"
                        class="w-100"
                        lazy-validation
                        @submit.prevent="loadReportsBetweenDates()"
                      >
                        <v-flex xs12>
                          <date-month-picker
                            label="Başlangıç Tarihi"
                            :rules="[
                              $rules.required({
                                falseValues: ['', undefined],
                                message: 'Bir başlangıç tarihi seçmelisiniz',
                              }),
                            ]"
                            @on:date-selected="
                              (val) => {
                                form.start_date = val;
                              }
                            "
                          >
                          </date-month-picker>
                        </v-flex>
                        <v-flex xs12>
                          <date-month-picker
                            label="Bitiş Tarihi"
                            :rules="[
                              $rules.required({
                                falseValues: ['', undefined],
                                message: 'Bir bitiş tarihi seçmelisiniz',
                              }),
                            ]"
                            @on:date-selected="
                              (val) => {
                                form.end_date = val;
                              }
                            "
                          >
                          </date-month-picker>
                        </v-flex>
                        <!--                        <v-flex xs12>
                          <v-checkbox
                            v-model="form.send_time"
                            class="mt-1 ml-n1 border-none"
                            label="Sadece ileri tarihli gönderimleri göster"
                          ></v-checkbox>
                        </v-flex>-->
                        <v-flex
                          xs12
                          class="d-flex justify-end justify-xl-space-between flex-wrap gap-1"
                        >
                          <v-btn
                            color="primary"
                            :disabled="
                              form.end_date === '' || form.start_date === ''
                            "
                            @click="resetForm()"
                          >
                            Seçimi Temizle
                          </v-btn>
                          <v-btn
                            color="primary"
                            type="submit"
                            :disabled="
                              form.end_date === '' || form.start_date === ''
                            "
                          >
                            <!-- :disabled="form.end_date === ''" -->
                            <!-- @click.stop="loadReportsBetweenDates" -->
                            Raporları Yükle
                          </v-btn>
                        </v-flex>
                      </v-form>
                    </v-flex>

                    <v-divider v-if="$vuetify.breakpoint.lgAndUp" vertical>
                    </v-divider>

                    <v-flex md12 xs12 xl9 class="overflow-auto">
                      <v-data-table
                        hide-default-footer
                        :headers="headers"
                        :items="data"
                      >
                        <template v-slot:item.is_next_time="{ item }">
                          <v-chip
                            color="red"
                            text-color="white"
                            v-if="item.status === 3"
                          >
                            İptal Edildi
                          </v-chip>
                          <v-chip
                            color="red"
                            text-color="white"
                            v-if="item.status === 2"
                          >
                            Başarısız
                          </v-chip>
                          <v-chip
                            color="green"
                            text-color="white"
                            v-if="item.status === 1 && item.send_time === ''"
                          >
                            Başarılı
                          </v-chip>
                          <v-chip
                            color="green"
                            text-color="white"
                            v-if="
                              item.send_time !== '' &&
                                item.status === 1 &&
                                !isFutureDate(shortenDate(item.send_time))
                            "
                          >
                            Başarılı
                          </v-chip>
                          <v-chip
                            color="orange"
                            text-color="white"
                            v-else-if="item.status === 0"
                          >
                            Beklemede
                          </v-chip>
                          <br />
                          <v-chip
                            style="margin-top: 5px;"
                            v-if="
                              item.send_time !== '' &&
                                item.status != 3 &&
                                isFutureDate(shortenDate(item.send_time))
                            "
                          >
                            <b>İleri Tarihli: </b>&nbsp;{{
                              shortenDate(item.send_time)
                            }}
                          </v-chip>
                          <v-btn
                            style="margin-top: 12px;"
                            class="warning"
                            v-if="
                              item.send_time !== '' &&
                                item.status != 3 &&
                                isFutureDate(shortenDate(item.send_time))
                            "
                            small
                            @click="cancelSms(item.id)"
                          >
                            İptal Et
                          </v-btn>
                        </template>
                        <template v-slot:item.group_names="{ item }">
                          <template v-if="item.groups.length > 0">
                            <v-chip
                              v-for="group in item.groups"
                              :key="group.id"
                              class="ma-1"
                              color="orange lighten-4"
                            >
                              {{
                                group && group.group && group.group.name
                                  ? group.group.name
                                  : ""
                              }}
                            </v-chip>
                          </template>
                          <template v-else>
                            -
                          </template>
                        </template>
                        <template v-slot:item.detail="{ item }">
                          <v-row justify="end" dense class="my-1">
                            <v-col cols="auto">
                              <v-btn dark @click="detail(item)" small
                                >Detay</v-btn
                              >
                            </v-col>
                            <v-col cols="auto">
                              <v-btn
                                color="primary"
                                @click="exportExcel(item)"
                                small
                              >
                                Excel
                              </v-btn>
                            </v-col>
                          </v-row>
                        </template>
                        <template v-slot:item.is_sub_user="{ item }">
                          <v-chip
                            v-if="item.is_sub_user === false"
                            v-text="'Ana Kullanıcı'"
                          >
                          </v-chip>
                          <v-chip
                            v-else
                            v-text="`Alt Kullanıcı: ${item.is_sub_user.name}`"
                          >
                          </v-chip>
                        </template>
                        <template v-slot:item.send_time="{ item }">
                          <v-chip
                            color="success"
                            v-if="item.send_time"
                            v-text="item.send_time"
                          >
                          </v-chip>
                          <v-chip v-if="item.deleted_at" color="error"
                            >İptal Edildi</v-chip
                          >
                        </template>
                      </v-data-table>
                      <pagination
                        :pagination="pagination"
                        :action="onPagination"
                      >
                      </pagination>
                    </v-flex>
                  </v-layout>
                </v-flex>
              </v-card-text>
            </v-card>
          </v-flex>
        </v-layout>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import { mapActions, mapState } from "vuex";
import Pagination from "../../Components/Datatables/Pagination.vue";
import DateMonthPicker from "../../Components/SMSConstants/DateMonthPicker.vue";
import { downloadFile } from "../../../misc";
import CardToolbar from "../../Components/CardToolbar.vue";
import DynamicAlert from "../../Components/DynamicAlert.vue";
import moment from "moment";

export default {
  name: "Report",
  components: {
    DynamicAlert,
    CardToolbar,
    DateMonthPicker,
    Pagination,
  },
  data: () => ({
    menu: false,
    isFormValid: true,
    isFiltered: false,
    // date: {
    //   start: '',
    //   end: '',
    // },
    form: {
      start_date: "",
      end_date: "",
      send_time: false,
    },
    // sorting values
    headers: [
      {
        text: "Tarih",
        value: "created_at",
      },
      {
        text: "Gruplar",
        value: "group_names",
        align: "center",
      },
      {
        text: "Mesaj",
        value: "message",
      },
      {
        text: "Durumu",
        value: "is_next_time",
        align: "center",
      },
      // {
      //   text: "Gönderim Öncesi Krediniz",
      //   value: "credit_before",
      //   align: "center",
      // },
      {
        text: "Toplam Gönderilen",
        value: "count",
        align: "center",
      },
      // {
      //   text: 'Başarısız',
      //   value: 'fail_old',
      //   align: 'center',
      // },
      // {
      //   text: 'Beklemede',
      //   value: 'waiting',
      //   align: 'center',
      // },
      // { text: 'Beklemede', value: 'waiting', align: 'center' },
      // {
      //   text: 'İade Edildi',
      //   value: 'returned',
      //   align: 'center',
      // },
      {
        text: "Işlem",
        value: "detail",
        align: "right",
      },
      {
        text: "Gönderen",
        value: "is_sub_user",
      },
    ],
    data: [],
    oztek: {
      account: null,
      loggedIn: false,
      info: "Api raporlarınızı buraya tıklayarak görebilirsiniz.",
    },
    pagination: {
      current: 1,
      total: 0,
    },
  }),
  computed: {
    ...mapState(["user"]),
    stationary() {
      return [
        {
          type: "warning",
          state: this.oztek.loggedIn,
          id: "warning",
        },
      ];
    },
  },
  watch: {
    // eslint-disable-next-line func-names
    "pagination.current": function() {
      // eslint-disable-next-line no-unused-expressions
      this.isFiltered ? this.loadReportsBetweenDates() : this.loadReports();
    },
  },
  created() {
    this.writepage();
    this.loadReports();
  },
  methods: {
    isFutureDate(date) {
      return moment(date, "DD/MM/YYYY hh:mm").isSameOrAfter(moment());
    },
    ...mapActions({ send: "sendBackend" }),
    ...mapActions({ sendAsync: "asyncSender" }),
    downloadFile,
    exportExcel(report) {
      const route = "export/report/details/";
      const fileName = `${this.user.id}-${report.created_at}`;
      this.$http
        .get(route + report.id, {
          responseType: "arraybuffer",
        })
        .then((res) => {
          this.downloadFile(res, fileName);
        });
    },
    formatGroupNames(groups) {
      if (groups.length === 0) {
        return "-";
      }
      return groups.map((group) => group.group.name).join(", ");
    },
    writepage() {
      if (this.$route.params.page) {
        this.pagination.current = this.$route.params.page;
      }
    },
    loadReports() {
      const url = `show/reports?page=${this.pagination.current}`;
      this.send({
        route: url,
      }).then((res) => {
        this.data = res.data.data.reports.data;
        this.oztek.account = res.data.data.oztek_account;
        this.oztek.loggedIn = true;
        this.pagination.current = res.data.data.reports.current_page;
        this.pagination.total = res.data.data.reports.last_page;
      });
    },
    loadReportsBetweenDates() {
      if (!this.$refs.form.validate()) {
        return;
      }

      // this.pagination.current = 1;
      this.isFiltered = true;

      const url = `show/reports/between?page=${this.pagination.current}`;
      this.send({
        route: url,
        data: {
          start_date: this.form.start_date,
          end_date: this.form.end_date,
          send_time: this.form.send_time,
        },
      }).then((res) => {
        this.data = res.data.data.data;
        this.pagination.current = res.data.data.current_page;
        this.pagination.total = res.data.data.last_page;
      });
    },
    onPagination($page = 1) {
      this.pagination.current = $page;
    },
    // loadReports() {
    //   this.pagination.current = 1;
    //   this.onPagination();
    // },
    // loadReportsBetweenDates() {
    //   this.pagination.current = 1;

    //   const url = `show/reports/between?page=${this.pagination.current}`;
    //   this.send({
    //     route: url,
    //     data: {
    //       start_date: this.date.start,
    //       end_date: this.date.end,
    //     },
    //   }).then((res) => {
    //     this.data = res.data.data.data;
    //     this.pagination.current = res.data.data.current_page;
    //     this.pagination.total = res.data.data.last_page;
    //   });
    // },
    // onPagination(data = {}) {
    //   const url = `show/reports?page=${this.pagination.current}`;
    //   this.send({
    //     route: url,
    //     data,
    //   }).then(async (res) => {
    //     this.data = await res.data.data.reports.data;
    //     this.oztek.account = await res.data.data.oztek_account;
    //     this.oztek.loggedIn = true;
    //     this.pagination.current = res.data.data.reports.current_page;
    //     this.pagination.total = res.data.data.reports.last_page;
    //   });
    // },
    cancelSms(id) {
      const route = "sms/cancel";
      this.send({
        route,
        data: { id },
      }).then(() => {
        const url = `show/reports?page=${this.pagination.current}`;
        this.sendAsync({ route: url });
      });
    },
    detail(report) {
      this.$router
        .push({
          name: "report.detail",
          params: {
            id: report.id,
            export: this.exportExcel,
            report,
            page: this.pagination.current,
          },
        })
        .catch(() => {});
    },
    resetForm() {
      this.form.start_date = "";
      this.form.end_date = "";
      this.$refs.form.reset();

      if (this.isFiltered) {
        this.loadReports();
        this.isFiltered = false;
      }
    },
    shortenDate(param) {
      const months = {
        Ocak: "01",
        Şubat: "02",
        Mart: "03",
        Nisan: "04",
        Mayıs: "05",
        Haziran: "06",
        Temmuz: "07",
        Ağustos: "08",
        Eylül: "09",
        Ekim: "10",
        Kasım: "11",
        Aralık: "12",
      };
      const [date, time] = param.split(",");
      const dateArr = date.split(" ");
      return `${dateArr[0]}/${months[dateArr[1]]}/${dateArr[2]}, ${
        time.split(" ")[2]
      }`;
    },
  },
};
</script>

<style scoped>
.text-decorative {
  text-decoration: underline;
}
</style>
